import React from 'react';
import { IconProps } from '.';

const SvgBoxPosty = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#000'
        d='M18.667 2H5.333A3.333 3.333 0 0 0 2 5.333v13.334A3.333 3.333 0 0 0 5.333 22h13.334A3.333 3.333 0 0 0 22 18.667V5.333A3.333 3.333 0 0 0 18.667 2Z'
      />
      <path
        fill='#fff'
        d='M16.169 8.285a2.864 2.864 0 0 0-.909-.991 4.152 4.152 0 0 0-1.361-.595 6.732 6.732 0 0 0-1.678-.199H8.5v11h2.626v-4.685h1.544c.478 0 .954-.064 1.415-.194.438-.12.851-.321 1.223-.592.354-.26.65-.599.866-.992.224-.423.336-.902.325-1.386.01-.478-.105-.95-.33-1.366Zm-2.525 2.212a2.094 2.094 0 0 1-.318.674 1.595 1.595 0 0 1-.55.463c-.245.117-.51.175-.779.169h-.87V7.589h.783c.242 0 .482.047.708.138.219.092.417.233.58.412.18.19.319.417.41.667.102.285.152.588.147.892 0 .27-.037.54-.11.799Z'
      />
    </svg>
  );
};

export default SvgBoxPosty;
